import { Nullable } from '$models'
import { StaffMember } from './staffMember'
import {
  StaffMemberAu,
  transformStaffMemberAuOnGet,
  transformStaffMemberAuOnSave,
} from './staffMemberAu'

export interface StaffMemberXeroAu extends StaffMemberAu {
  ordinaryEarningsRateId: Nullable<string>
}

// Function to apply transformations to StaffMemberXeroAu object on get
export const transformStaffMemberXeroAuOnGet = (
  staffMember: StaffMember
): StaffMemberXeroAu => {
  const transformedStaffMember = transformStaffMemberAuOnGet(
    staffMember
  ) as StaffMemberXeroAu

  return transformedStaffMember
}

// Function to apply transformations to StaffMemberXeroAu object on get
export const transformStaffMemberXeroAuOnSave = (
  staffMember: StaffMember
): object => {
  const staffMemberXeroAU = staffMember as unknown as StaffMemberXeroAu
  const transformedStaffMember = transformStaffMemberAuOnSave(staffMember)

  // calendarId comes through the spread above, already named the way the API wants it
  return {
    ...transformedStaffMember,
    ordinaryEarningsRate: staffMemberXeroAU.ordinaryEarningsRateId,
  }
}
